import { REHYDRATE } from 'redux-persist'
import { cookiesTool } from 'react-gdpr'
import { all, call, fork, put, SagaReturnType, select, takeLeading } from 'redux-saga/effects'

import { actions, selectors } from '..'
import AuthSagas from '../auth/sagas'
import ConfigurationSagas from '../configuration/sagas'

export default class AppSagas {
  static *init() {
    const isInit: SagaReturnType<typeof selectors.app.isInit> = yield select(selectors.app.isInit)
    yield call(AuthSagas.onInit) // must be first auth call to refresh token if needed
    yield call(AppSagas.initTracking)
    yield fork(AppSagas.loadInitialData) // can be forked
    yield call(ConfigurationSagas.init)

    if (!isInit) {
      yield put(actions.app.setIsInit({ isInit: true }))
    }
  }

  static *loadInitialData() {
    yield all([])
  }

  static initTracking() {
    if (cookiesTool.isActive('cookiesEdited') && !cookiesTool.isActive('analytics')) {
      cookiesTool.setActive('analytics', false)
    }
  }

  static *listeners() {
    yield all([takeLeading(REHYDRATE, this.init)])
  }
}
